if (!customElements.get("wdn-dropdown")) {
  class WDNDropdown extends HTMLElement {
    constructor() {
      super();
      this.buildConstructor();
      if (!this.autoInit) return;
      this.init();
    }

    configureAttributes() {
      this.nameSpace = this.getAttribute("data-name") || "dropdown";

      this.selectors = {
        trigger: "[" + this.nameSpace + "-trigger]",
        container: "[" + this.nameSpace + "-container]",
        content: "[" + this.nameSpace + "-content]",
      };

      this.attributeList = {
        group: "group",
        active: this.nameSpace + "-active",
        resetHeight: "data-reset-height",
        animation: this.nameSpace + "-animate",
        active_on: "active-on",
      };
    }

    buildConstructor() {
      this.configureAttributes();
      this.triggers = this.querySelectorAll(this.selectors.trigger);
      this.container = this.querySelector(this.selectors.container);
      this.content = this.querySelector(this.selectors.content);
      this.group = this.getAttribute(this.attributeList.group);
      this.isActive = this.getAttribute(this.attributeList.active) === "";
      this.resetHeight =
        this.getAttribute(this.attributeList.resetHeight) === "";
      this.animation =
        parseInt(this.getAttribute(this.attributeList.animation)) || 0;
      this.autoInit = !(this.getAttribute("data-autoinit") === "false");
      this.restrictions = {
        is_restricted: this.hasAttribute(this.attributeList.active_on),
        active_on: this.getAttribute(this.attributeList.active_on),
        valid_list: ["mobile", "desktop"],
        vp_width: 900,
      };
      this.setConditionals();
    }

    setConditionals() {
      // Used to determine if clicks should be disabled based on these conditionals.
      this.conditionals = [
        window.innerWidth >= this.restrictions.vp_width &&
          this.restrictions.active_on === this.restrictions.valid_list[0],
        window.innerWidth < this.restrictions.vp_width &&
          this.restrictions.active_on === this.restrictions.valid_list[1],
      ];
    }

    setState(newState) {
      this.isActive = newState;
    }

    setContainerHeight(newHeight) {
      var value = newHeight;
      if (typeof newHeight === "number") {
        value = newHeight + "px";
      }
      this.container.style.height = value;
    }

    shrinkContainer() {
      this.setContainerHeight(this.initialHeight);
    }

    expandContainer() {
      var contentHeight = this.content.offsetHeight;
      this.setContainerHeight(contentHeight);
    }

    setInactive() {
      this.expandContainer();
      setTimeout(
        function () {
          this.setState(false);
          this.removeAttribute(this.attributeList.active);
          this.shrinkContainer();

          // this will help when extending the component
          if (typeof this.onClose === "function") {
            this.onClose();
          }
        }.bind(this),
        50
      );
    }

    scrollTop() {
      if (!this.classList.contains("scroll-top--on-active")) return;

      let offsetTop =
        100 +
        parseInt(
          getComputedStyle(document.documentElement).getPropertyValue(
            "--nav-height"
          )
        );

      setTimeout(() => {
        window.scrollTo({
          behaviour: "smooth",
          top: this.getBoundingClientRect().top + window.scrollY - offsetTop,
        });
      }, 350);
    }

    setActive() {
      this.collapseGroupContainers();
      this.setState(true);
      this.setAttribute(this.attributeList.active, "");
      this.expandContainer();

      this.scrollTop();
      // this will help when extending the component
      if (typeof this.onOpen === "function") {
        this.onOpen();
      }
    }

    fireGroupEvent() {
      var customEvent = new CustomEvent("dropdown:group:collapse", {
        detail: { initiator: this, group: this.group },
      });
      document.body.dispatchEvent(customEvent);
    }

    collapseGroupContainers() {
      if (this.group) {
        this.fireGroupEvent();
      }
    }

    beforeInactive() {
      this.expandContainer();
    }

    afterActive() {
      if (!this.animation) return;
      setTimeout(
        function () {
          this.setContainerHeight("auto");
        }.bind(this),
        this.animation
      );
    }

    validateActiveOn() {
      var valid = true;
      if (!this.restrictions.is_restricted) return valid;
      if (
        this.restrictions.valid_list.indexOf(this.restrictions.active_on) === -1
      )
        return valid;
      if (this.conditionals.some((condition) => condition === true))
        valid = false;

      return valid;
    }

    onTriggerClick() {
      // Check if restricted to only be used phone/desktop. Looks at active-on attribute and if it has been set to mobile or desktop, then break.
      if (!this.validateActiveOn()) return;

      if (this.isActive) {
        this.beforeInactive();
        this.setInactive();
      } else {
        this.setActive();
        this.afterActive();
      }

      if (typeof this.onClick === "function") {
        this.onClick();
      }
    }

    onWindowResize() {
      this.setConditionals();
      if (this.isActive) {
        this.expandContainer();
      }
    }

    onGroupCollapse(e) {
      if (e.detail.initiator === this) return;
      if (this.group === e.detail.group && this.isActive) {
        this.setInactive();
      }
    }

    setInitialState() {
      if (this.isActive) {
        this.expandContainer();
      }
    }

    storeInitialHeight() {
      this.initialHeight = parseInt(this.container.style.height) || 0;
    }

    bind() {
      this.triggers.forEach((trigger) =>
        trigger.addEventListener("click", this.onTriggerClick.bind(this))
      );
      document.body.addEventListener(
        "dropdown:group:collapse",
        this.onGroupCollapse.bind(this)
      );
      window.addEventListener("resize", this.onWindowResize.bind(this));
    }

    init() {
      this.storeInitialHeight();
      this.setInitialState();
      this.bind();
    }
  }
  customElements.define("wdn-dropdown", WDNDropdown);
}
